module.exports = __webpack_public_path__ + "static/media/upgrade_screen_example.59b8346d.png";